module.exports = {"Type":"SendEmail","Disabled":false,"Output":true,"Fields":[{"label":"Text","type":"multiline","name":"text","serializeTo":"q"},{"label":"Subject","name":"name","serializeTo":"node"},{"label":"Recipients","type":"multiline","name":"intent"},{"label":"Publisher visibility","type":"yesno","name":"publisher","defaultValue":"No"},{"label":"Text attachment","name":"textattachment","advanced":true},{"label":"Attachment Url","name":"urlattachment","advanced":true}],"Header":{"Color":"white","BackgroundColor":"brown","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/SendEmail.json
// module id = 704
// module chunks = 0